import IconLabel from "../widgets/iconLabel";
import clockIcon from "../../assets/svgs/clock.svg";
import topicIcon from "../../assets/images/topic_icon.png";
import questionIcon from "../../assets/images/question_paper_icon.png";
import QuestionsList from "../dashboard/optionmodes/questionsList";
import SelectedTopic from "../widgets/selectedTopic";
import { useState, useEffect } from "react";
import "./previewAssessment.css";
import { getDraft, isDraftExists} from "../../utilities/utility";
import { toast } from "react-toastify";
import axios from "axios";
import {
  API_ENDPOINT,
  HEADER_TOKEN,
} from "../../constants/constants";
const PreviewAssessment = () => {
  const [at, setAt] = useState("");
  const [ad, setAd] = useState(30);
  const [banner, setBanner] = useState("");
  const [questions, setQuestions] = useState([]);
  const [useDraft, setUseDraft] = useState(false);
  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");

  useEffect(() => {
    if (keysUrl[5]) {
      let linkCode = keysUrl[5];
      setUseDraft(false);
      loadAssessment(linkCode);
    } else if (isDraftExists()) {
      setUseDraft(true);
      let a = getDraft();
      if (typeof a.duration !== "number") a.duration = 30;
      setBanner(a.banner);
      setAt(a.title);
      setAd(a.duration);
      setQuestions(a.questions);
    } else setUseDraft(true);

    //checkPlan()
  }, []);

  function loadAssessment(linkCode) {
    axios
      .post(
        API_ENDPOINT + "trainer/get-assessment",
        { linkCode: linkCode },
        HEADER_TOKEN
      )
      .then((res) => {
        let d = res.data;
        if (d.success) {
          let a = d.message;
          setBanner(a.banner);
          setAt(a.title);
          setAd(a.duration);
          setQuestions(a.questions);
        } else {
          toast(d.message);
        }
      });
  }

  let uniqueObjArray = [
    ...new Map(questions.map((item) => [item["topic"], item])).values(),
  ];

  let result = questions.reduce(function (acc, curr) {
    // Check if there exist an object in empty array whose CategoryId matches
    let isElemExist = acc.findIndex(function (item) {
      return item.topic === curr.topic;
    });
    if (isElemExist === -1) {
      let obj = {};
      obj.topic = curr.topic;
      obj.count = 1;
      acc.push(obj);
    } else {
      acc[isElemExist].count += 1;
    }
    return acc;
  }, []);

  return (
    <div className="assessment-preview">
      <div style={{ display: "flex" }}>
        <div style={{ flex: 0.4, position: "relative", height: "70vh" }}>
          <div style={{ marginLeft: 10, marginRight: 10, marginTop: "8px" }}>
            <div style={{ display: "flex" }}>
              {banner ? (
                <img
                  src={banner}
                  style={{
                    borderRadius: "50%",
                    width: "144px",
                    height: "144px",
                    objectFit: "cover",
                  }}
                  alt=""
                />
              ) : (
                ""
              )}
              <div style={{ marginLeft: "16px" }}>
                <div style={{ fontWeight: 600, fontSize: 18 }}>{at}</div>
                <IconLabel
                  icon={clockIcon}
                  isMUI={false}
                  label={`${ad} minutes`}
                  is={16}
                  ls={14}
                  gap={10}
                />
                <IconLabel
                  icon={topicIcon}
                  isMUI={false}
                  label={`${result.length} Topics Added`}
                  is={16}
                  ls={14}
                  gap={10}
                />
                <IconLabel
                  icon={questionIcon}
                  isMUI={false}
                  label={`${questions.length} Questions Added`}
                  is={16}
                  ls={14}
                  gap={10}
                />
              </div>
            </div>
            <div style={{ marginTop: "12px" }}>
              {result.map((r,i) => (
                <SelectedTopic key={i} isPreview={true} topic={r.topic} num={r.count} />
              ))}
            </div>
          </div>
        </div>
        <div style={{ flex: 0.6 }}>
          <QuestionsList
            questions={questions}
            setQuestions={setQuestions}
            useDraft={useDraft}
            page="single_preview"
          />
        </div>
      </div>
    </div>
  );
};
export default PreviewAssessment;
